import TrustedContactDevilSvg from "@assets/media/safer-dating/trusted-contact-devil.svg"
import IntroBottomBorderDesktopSvg from "@assets/media/safer-dating/intro-bottom-border-desktop.svg"
import IntroBottomBorderMobileSvg from "@assets/media/safer-dating/intro-bottom-border-mobile.svg"
import IntroDescriptionBorderSvg from "@assets/media/safer-dating/intro-description-border.svg"
import IntroDescriptionBorderMobileSvg from "@assets/media/safer-dating/intro-description-border-mobile.svg"
import IntroDescriptionDevilSvg from "@assets/media/safer-dating/intro-description-devil.svg"

type IntroSectionProps = {
  title: string
  description: string
}

export function IntroSection({ title, description }: IntroSectionProps) {
  return (
    <section className="overflow-hidden relative bg-safer-dating-intro bg-cover bg-no-repeat bg-center px-[24px] mb-3 tablet-m:mb-0 tablet-m:flex tablet-m:justify-center tablet-m:px-5">
      <TrustedContactDevilSvg className="absolute max-w-[170px] rotate-[-20deg] top-[24px] right-[-74px] tablet-m:top-0 tablet-m:right-0 tablet-m:rotate-[-6.5deg] tablet-m:relative tablet-m:max-w-[350px] tablet-m:mr-[100px] tablet-m:mt-[100px] tablet-m:mb-[-20px]" />
      <IntroBottomBorderDesktopSvg className="hidden tablet-m:block absolute bottom-0 w-full" />
      <IntroBottomBorderMobileSvg className="left-0 tablet-m:hidden absolute bottom-0 w-full" />
      <div className="tablet-m:mt-[68px]">
        <h2 className="max-w-[184px] text-[32px] leading-[40px] pt-[32px] rotate-[-4deg] tablet-m:max-w-[490px] tablet-m:pt-0 tablet-m:text-[64px] tablet-m:leading-[70px] tablet-m:tracking-[1px]  tablet-m:mb-[68px] font-quirk-bold">
          {title}
        </h2>
        <p className="relative max-w-[312px] mt-4 rotate-[-2deg] tablet-m:rotate-[0deg] tablet-m:max-w-[676px]">
          <IntroDescriptionDevilSvg className="hidden tablet-m:block absolute top-[-62px] right-[42px]" />
          <IntroDescriptionBorderSvg className="hidden tablet-m:block absolute w-full h-full top-0" />
          <IntroDescriptionBorderMobileSvg className="tablet-m:hidden rotate-[2deg] absolute w-full h-full top-0" />
          <span className="relative inline-block px-[40px] py-7 text-[16px] leading-[20px] tablet-m:py-[48px] tablet-m:text-[24px] tablet-m:leading-[32px]">
            {description}
          </span>
        </p>
      </div>
    </section>
  )
}
